import React, { useRef } from 'react'

import AssetHandler from '@adUtilities/asset-handler/asset-handler'
import { FileType } from '@adUtilities/constants'

const videoSrc = `${process.env.REACT_APP_BUCKET}/hidden-video.mp4`

function HiddenVideo() {
  const videoRef = useRef<HTMLVideoElement>(null)

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      loop
      playsInline
      onError={(e) => console.error('Video error', e)}
      style={{
        position: 'fixed',
        width: 1,
        height: 1,
        opacity: 0,
      }}
    >
      <source
        src={AssetHandler({
          url: videoSrc,
          type: 'new',
          fileType: FileType.Video,
        })}
        type="video/mp4"
      />
    </video>
  )
}

export default HiddenVideo
